import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {

  constructor() { }

  getErrorMessage(response) {
    if (response.status === 400 || response.status === 401) {
      return response?.error?.details?.error?.message ? response?.error?.details?.error?.message : response?.error?.details?.message;
    } else if (response.status === 422) {
      const errorArr = [];
      const validation_errors = response.error.details;
      validation_errors.forEach(error => {
        errorArr.push(error?.message);
      });
      return errorArr;
    }
    return 'Unknown error occured, Please try again.';
  }

  getErrorMessageV2(response) {
    if (response.status === 400 || response.status === 401) {

      return response?.error?.details?.error?.message ? response?.error?.details?.error?.message : response?.error?.details?.message;
    } else if (response.status === 422) {
      const errorArr = [];
      const validation_errors = response.error.errors;
      validation_errors.forEach(error => {
        errorArr.push(error?.message);
      });
      return errorArr;
    }
    
    return 'Unknown error occured, Please try again.';
  }
}
